<h1 class="text-dark text-xl" mat-dialog-title>Crea fondo cassa</h1>
<div class="w-full" mat-dialog-content>
  <app-create-cash-found-form
    [data]="cashFound"
    [dialogRef]="dialogRef"
  ></app-create-cash-found-form>
</div>
